var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[(_vm.homeContent)?_c('div',[_c('VueShowdown',{attrs:{"markdown":this.homeContent.content}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }